export default {
  user: {},
  listItemSelected: []
}
